import { render, staticRenderFns } from "./PartnerTransfer.vue?vue&type=template&id=affae644&scoped=true&"
import script from "./PartnerTransfer.vue?vue&type=script&lang=js&"
export * from "./PartnerTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTransfer.vue?vue&type=style&index=0&id=affae644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affae644",
  null
  
)

export default component.exports